'use client';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import { cn } from 'src/app/lib/utils/tailwindcss';

import DrawerMenu from './DrawerMenu/DrawerMenu';
import MenuToggle from './MenuToggle';

// 설레임런 헤더 — COOLish 로고 + 햄버거 메뉴(드로어).
export default function Header() {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const prevPathnameRef = useRef(pathname);

  const handleMenuToggle = () => setIsOpen((prev) => !prev);

  // 드로어 열림 시 body 스크롤 잠금
  useEffect(() => {
    const body = document.querySelector('body');
    if (!body) return;
    body.style.overflow = isOpen ? 'hidden' : '';
    return () => {
      body.style.overflow = '';
    };
  }, [isOpen]);

  // 스크롤 다운 시 헤더 숨김 (최상단에선 항상 노출)
  useEffect(() => {
    let prevScroll = window.scrollY;

    const scrollHandler = () => {
      const currentScroll = window.scrollY;
      const isScrollDown = prevScroll <= currentScroll;

      if (currentScroll === 0) {
        setIsHidden(false);
      } else {
        setIsHidden(isScrollDown);
      }

      prevScroll = currentScroll;
    };

    window.addEventListener('scroll', scrollHandler, { passive: true });
    return () => window.removeEventListener('scroll', scrollHandler);
  }, []);

  // 경로 변경 시 드로어 자동 닫기
  useEffect(() => {
    if (prevPathnameRef.current !== pathname) {
      prevPathnameRef.current = pathname;
      requestAnimationFrame(() => setIsOpen(false));
    }
  }, [pathname]);

  return (
    <header className="flex flex-col items-center justify-center">
      <nav
        className={cn(
          'fixed top-0 right-0 left-0 z-201 mx-auto flex h-seoleimrun-gnb w-full max-w-[480px] flex-row items-center justify-between border-b-[0.5px] border-seoleimrun-primary-10 bg-seoleimrun-brand-01 px-6 py-[14px] opacity-100 transition-all duration-250 ease-in-out',
          isHidden && '-translate-y-seoleimrun-gnb transform opacity-0',
        )}
      >
        <Link href="/seoleimrun" aria-label="설레임런 홈" className="flex items-center">
          <Image
            src="https://cdn.kottonseed.io/assets/seoleimrun/common/logo.webp"
            alt="설레임런"
            width={65}
            height={36}
            priority
          />
        </Link>
        <MenuToggle isOpen={isOpen} setOpen={handleMenuToggle} />
      </nav>

      <DrawerMenu isOpen={isOpen} setOpen={handleMenuToggle} />
    </header>
  );
}
